module.exports = __webpack_public_path__ + "static/media/icon_calendario.c7c85fa3.png";